import { render, staticRenderFns } from "./RomaFooter.vue?vue&type=template&id=9de373de"
import script from "./RomaFooter.vue?vue&type=script&lang=ts"
export * from "./RomaFooter.vue?vue&type=script&lang=ts"
import style0 from "./RomaFooter.vue?vue&type=style&index=0&id=9de373de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports